import { render, staticRenderFns } from "./main-displays.vue?vue&type=template&id=12ead4cb&scoped=true&"
import script from "./main-displays.vue?vue&type=script&lang=js&"
export * from "./main-displays.vue?vue&type=script&lang=js&"
import style0 from "./main-displays.vue?vue&type=style&index=0&id=12ead4cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ead4cb",
  null
  
)

export default component.exports